<po-modal #modal [p-hide-close]="true" [p-primary-action]="primaryActionTerminal"
    [p-secondary-action]="secondaryActionTerminal" p-title="Seleção de Terminal">
    <div class="po-pr-2 po-pl-1 po-mb-2">
        <po-combo name="combo-terminal" (p-change)="setTerminal($event)" p-label="Selecione um terminal"
            p-placeholder="Selecione um terminal" [p-options]="terminalList" [ngModel]="terminalSelected"
            [p-remove-initial-filter]="removeInitialFilter" [p-disabled-init-filter]="removeInitialFilter"
            [p-clean]="true">
        </po-combo>
    </div>
    <div *ngIf="isLoading" class="sample-container">
        <po-loading-overlay [p-text]="text" [p-size]="size">
        </po-loading-overlay>
    </div>
</po-modal>